'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createStore;

var _redux = require('redux');

var _clientMiddleware = require('./middleware/clientMiddleware');

var _clientMiddleware2 = _interopRequireDefault(_clientMiddleware);

var _analyticsMiddleware = require('./middleware/analyticsMiddleware');

var _analyticsMiddleware2 = _interopRequireDefault(_analyticsMiddleware);

var _backMiddleware = require('./middleware/backMiddleware');

var _backMiddleware2 = _interopRequireDefault(_backMiddleware);

var _reactRouterRedux = require('react-router-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createStore(history, client, data) {
  // Sync dispatched route actions to the history
  // const reduxRouterMiddleware = syncHistory(history);
  var reduxRouterMiddleware = (0, _reactRouterRedux.routerMiddleware)(history);

  // const middleware = [createMiddleware(client), backMiddleware, reduxRouterMiddleware, thunk, analyticsMiddleware];
  var middleware = [(0, _clientMiddleware2.default)(client), _backMiddleware2.default, reduxRouterMiddleware, _analyticsMiddleware2.default];

  var finalCreateStore = void 0;
  if (__DEVELOPMENT__ && __CLIENT__ && __DEVTOOLS__) {
    var _require = require('redux-devtools'),
        persistState = _require.persistState;

    var DevTools = require('../containers/DevTools/DevTools');
    finalCreateStore = (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, middleware), window.devToolsExtension ? window.devToolsExtension() : DevTools.instrument(), persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/)))(_redux.createStore);
  } else {
    finalCreateStore = _redux.applyMiddleware.apply(undefined, middleware)(_redux.createStore);
  }

  var reducer = require('./modules/reducer');
  var store = finalCreateStore(reducer, data);

  // reduxRouterMiddleware.listenForReplays(store);

  if (__DEVELOPMENT__ && module.hot) {
    module.hot.accept('./modules/reducer', function () {
      store.replaceReducer(require('./modules/reducer'));
    });
  }

  return store;
}
// import thunk from 'redux-thunk';
// import { syncHistory } from 'react-router-redux';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/create.js
// module id = 1697
// module chunks = 47